<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode ? $t('surgery.Create-Surgery') : $t('surgery.Edit-Surgery')
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.name')" label-for="title">
              <b-form-input
                v-model="EditForm.title"
                :placeholder="$t('common.name')"
                :state="errorForm.title ? false : null"
              />
              <p class="text-danger mt-1">{{ errorForm.title }}</p>
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group :label="$t('common.Select-Type')" label-for="Type">
              <v-select
                v-model="EditForm.type"
                :options="surgeryTypesList"
                label="text"
                :reduce="(status) => status.value"
                :placeholder="$t('common.Select-Type')"
              />
              <p class="text-danger mt-1">{{ errorForm.type }}</p>
            </b-form-group>
          </b-col>
          <!-- <b-col md="">
            <b-form-group :label="$t('common.price')" label-for="PRICE">
              <b-form-input
                type="number"
                v-model="EditForm.price"
                :placeholder="$t('common.price')"
                :state="errorForm.price ? false : null"
              />
              <p class="text-danger mt-1">{{ errorForm.price }}</p>
            </b-form-group>
          </b-col> -->
          <b-col md="">
            <b-form-group
              :label="$t('common.description')"
              label-for="Description"
            >
              <b-form-input
                v-model="EditForm.description"
                :placeholder="$t('common.description')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <SurgeryCategorySelect
              v-model="EditForm.surgery_category_id"
              :error-message="errorForm.surgery_category_id"
            />
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t('common.add') }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-row>
      <b-col
        lg="12"
        sm="12"
        v-if="$store.state.app.permissions.includes('get-doctorSurgery')"
      >
        <b-link :to="{ name: 'doctor-surgery' }">
          <statistic-card-horizontal
            icon=""
            :statistic="$t('surgery.Doctors-Surgery')"
            class="modify"
          />
        </b-link>
      </b-col>
    </b-row>
    <b-card :title="$t('surgery.surgery')">
      <!-- Search Patient Name -->
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t('surgery.Filter-Surgery') }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="surgeryName"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.Select-Type')" label-for="Type">
              <v-select
                v-model="surgeryType"
                :options="surgeryTypesList"
                label="text"
                :reduce="(status) => status.value"
                :placeholder="$t('common.Select-Type')"
              />
            </b-form-group>
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.price')" label-for="Price">
              <b-form-input
                id="Price"
                type="number"
                v-model="surgeryPrice"
                :placeholder="$t('common.price')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getSurgeryList()">
              {{ $t('common.search') }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t('surgery.surgery') }}</h2>
          <b-button
            v-b-modal.modal-prevent-closing
            variant="primary"
            @click="show(EditForm, 'create')"
            v-if="$store.state.app.permissions.includes('store-surgery')"
          >
            {{ $t('surgery.Create-Surgery') }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(type)="data">
            <div class="text-nowrap">
              {{ getSurgeryTypeName(data.item.type) }}
            </div>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->
              <ActionsButtons
                deletePerm="delete-surgery"
                editPerm="update-surgery"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getSurgeryList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormSelect,
  BLink,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue';
import permissionChecker from '@/mixins/permissionChecker';
import vSelect from 'vue-select';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import ActionsButtons from '@/components/common/ActionsButtons.vue';
import SurgeryCategorySelect from '@/components/surgery/SurgeryCategorySelect.vue';

export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,

    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormSelect,
    BLink,
    StatisticCardHorizontal,
    vSelect,
    SurgeryCategorySelect,
  },
  data() {
    return {
      take: 10,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        title: '',
        price: '',
        type: 0,
        description: '',
        surgery_category_id: null,
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        title: '',
        price: '',
        type: '',
        description: '',
        surgery_category_id: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        { key: 'title', sortable: true, label: this.$t('common.name') },
        { key: 'type', sortable: true, label: this.$t('common.type') },
        // { key: 'price', sortable: true, label: this.$t('common.price') },
        {
          key: 'surgery_category_name',
          sortable: true,
          label: this.$t('surgery.surgery-category') || 'تصنيف العملية',
        },
        {
          key: 'description',
          sortable: true,
          label: this.$t('common.description'),
        },
        { key: 'created_at', sortable: true, label: this.$t('common.created_at') },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      surgeryTypesList: [
        {
          text: 'كبرى ',
          value: '1',
        },
        {
          text: 'صغرى ',
          value: '2',
        },
        {
          text: 'متوسطة',
          value: '3',
        },
        {
          text: 'فوق الكبرى',
          value: '4',
        },
        {
          text: 'خاصة',
          value: '5',
        },
      ],
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
      surgeryType: '',
      surgeryName: '',
      surgeryPrice: '',
    };
  },
  mounted() {
    this.getSurgeryList();
  },
  methods: {
    show(item, mode) {
      if (mode === 'create') {
        this.createMode = true;
        this.EditForm = {
          title: '',
          type: '',
          price: '',
          description: '',
          surgery_category_id: null,
          _method: 'POST',
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.title = item.title;
        this.EditForm.type = item.type;
        this.EditForm.price = item.price;
        this.EditForm.description = item.description;
        this.EditForm.surgery_category_id = item.surgery_category_id;
        this.EditForm._method = 'PUT';
      }
      this.$bvModal.show('modal-edit');
    },

    getSurgeryTypeName(value) {
      console.log(value);
      switch (value.toString()) {
        case '1':
          return 'كبرى';
        case '2':
          return 'صغرى';
        case '3':
          return 'متوسطة';
        case '4':
          return 'فوق الكبرى';
        case '5':
          return 'خاصة';
        default:
          return '';
      }
    },

    async getSurgeryList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/surgery?page=${this.page}&take=${this.take}&sort=-id&include[]=surgeryCategory`;

      if (this.surgeryName) {
        url += `&filter[title]=${this.surgeryName}`;
      }
      if (this.surgeryType) {
        url += `&filter[type]=${this.surgeryType}`;
      }
      if (this.surgeyPrice) {
        url += `&filter[price]=${this.surgeyPrice}`;
      }
      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = (this.all_data.data || []).map((item) => ({
        ...item,
        surgery_category_name: item.surgery_category?.name || '-',
      }));
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-delete');
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/surgery/${this.deleteForm.id}`)
        .then((response) => {
          this.getSurgeryList();

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem(bvModalEvent) {
      bvModalEvent.preventDefault();
      let count = 0;
      this.loading = true;
      this.errorForm.title = '';
      this.errorForm.type = '';
      this.errorForm.price = '';
      this.errorForm.surgery_category_id = '';

      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.EditForm[item] == '' || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.title) {
        count++;
        this.errorForm.title = 'The title field is required.';
      }
      if (!this.EditForm.type) {
        count++;
        this.errorForm.type = 'The type field is required.';
      }
      // if (!this.EditForm.price) {
      //   count++;
      //   this.errorForm.price = 'The price field is required.';
      // }
      if (count > 0) {
        this.loading = false;
        return false;
      }
      this.EditForm.price = 0;
      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/surgery`),
          this.$store
            .dispatch('create', this.params)
            .then((response) => {
              this.$bvModal.hide('modal-edit');
              this.getSurgeryList();
              this.loading = false;
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.loading = false;
                Object.keys(error.response.data).forEach((item) => {
                  this.errorForm[item] = error.response.data[item][0];
                });
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/surgery/${this.EditForm.id}`),
          this.$store
            .dispatch('update', this.params)
            .then((response) => {
              this.$bvModal.hide('modal-edit');
              this.getSurgeryList();
              this.loading = false;
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.loading = false;
                Object.keys(error.response.data).forEach((item) => {
                  this.errorForm[item] = error.response.data[item][0];
                });
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
